import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const semiboldFontWeight = String(
    theme.fontWeightSemibold
  ) as TextStyle['fontWeight']

  return {
    base: {
      fontFamily: 'RDModern-SemiBold',
      fontWeight: semiboldFontWeight,
      textAlign: 'center',
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      backgroundColor: 'transparent',
      color: theme.colorLabelingTextPrincipalDefault,
      fontSize: theme.fontSizeThreepulse,
      height: theme.sizingExtrasmall,
      flexShrink: 1,
      flexWrap: 'wrap',
      overflow: 'hidden',
      lineHeight: convertLineHeight(
        theme.fontSizeThreepulse,
        theme.lineHeightMedium
      ),
    },
    variants: {
      variant: {
        'on-sale': {
          color: theme.colorLabelingTextOnsaleDefault,
        },
        principal: {
          color: theme.colorLabelingTextPrincipalDefault,
        },
        secondary: {
          color: theme.colorLabelingTextSecondaryDefault,
        },
        'clube-raia': {
          color: theme.colorLabelingTextClubeDefault,
        },
        'clube-drogasil': {
          color: theme.colorLabelingTextClubeDefault,
        },
        assinatura: {
          color: theme.colorLabelingTextAssinaturaDefault,
        },
        generico: {
          color: theme.colorLabelingTextGenericoDefault,
        },
        'medicamento-de-geladeira': {
          color: theme.colorLabelingTextRefrigerateDefault,
        },
        'receita-obrigatoria': {
          color: theme.colorLabelingTextPrescriptionDefault,
        },
        referencia: {
          color: theme.colorLabelingTextReferenciaDefault,
        },
        similar: {
          color: theme.colorLabelingTextSimilarDefault,
        },
        'ganhe-stix': {
          color: theme.colorLabelingTextStixDefault,
        },
        'trocar-stix': {
          color: theme.colorLabelingTextStixDefault,
        },
      },
    },
  }
})
